import React from "react"
import Header from "./components/Header"
import Form from "./components/Form"
import Resumen from "./components/Resumen"
import Resultado from "./components/Resultado"
import Spinner from "./components/Spinner"
import styled from "@emotion/styled"
import { useState } from "react"

const Container = styled.div`
  max-width: 600px;
  margin: 0 auto;
`

const FormContainer = styled.div`
  background-color: #FFF;
  padding: 3rem;
`

function App() {

  const [resumen, setResumen] = useState({
    cotizacion: 0,
    data: {
      marca: "",
      year: "",
      plan: ""
    }
  })

  const [isLoading, setIsLoading] = useState(false)

  const { cotizacion, data } = resumen

  return (
      <Container>
        <Header titulo="Cotizador" />
        <FormContainer>
          <Form 
            setResumen={setResumen}
            setIsLoading={setIsLoading}
          /> 
          {isLoading ? <Spinner /> : null}
          <Resumen 
            data={data}
          />
          {!isLoading 
          ? (
              <Resultado 
                cotizacion={cotizacion}
              />
          ) : null}
          
        </FormContainer>
      </Container>
  )
}

export default App;
